"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var condo_brain_1 = require("condo-brain");
var moment_1 = __importDefault(require("moment"));
require("./styles/application.scss");
require("./styles/parking.scss");
var addMinutes = function (date, min) {
    var updatedDate = new Date(date);
    updatedDate.setMinutes(date.getMinutes() + min);
    return updatedDate;
};
var roundToMinuteInterval = function (date, interval) {
    var time = (date.getHours() * 60) + date.getMinutes();
    var rounded = Math.round(time / interval) * interval;
    var roundedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Math.floor(rounded / 60), rounded % 60);
    return roundedDate;
};
var formatDate = function (date) {
    var month = date.toLocaleDateString().split('/')[0];
    var day = date.toLocaleDateString().split('/')[1];
    var year = date.toLocaleDateString().split('/')[2];
    if (parseInt(month, 10) < 10) {
        month = "0".concat(month);
    }
    if (parseInt(day, 10) < 10) {
        day = "0".concat(day);
    }
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var formatTime = function (date) {
    var options = { hour12: false, hour: '2-digit', minute: '2-digit' };
    return date.toLocaleTimeString([], options);
};
function ElevatorBooking(_a) {
    var userManager = _a.userManager;
    var _b = (0, react_1.useState)(roundToMinuteInterval(new Date(), 15)), selectedStartDate = _b[0], setSelectedStartDateChange = _b[1];
    var _c = (0, react_1.useState)(addMinutes(selectedStartDate, 30)), selectedEndDate = _c[0], setSelectedEndDateChange = _c[1];
    var _d = (0, react_1.useState)(false), thanks = _d[0], setThanks = _d[1];
    var _e = (0, react_1.useState)(''), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = (0, react_1.useState)(0), moveType = _f[0], setMoveType = _f[1];
    var _g = (0, react_1.useState)(userManager.fullname), name1 = _g[0], setName1 = _g[1];
    var _h = (0, react_1.useState)(null), name2 = _h[0], setName2 = _h[1];
    var _j = (0, react_1.useState)(userManager.phone), phoneDay = _j[0], setPhoneDay = _j[1];
    var _k = (0, react_1.useState)(null), phoneNight = _k[0], setPhoneNight = _k[1];
    var _l = (0, react_1.useState)(0), deposit = _l[0], setDeposit = _l[1];
    var _m = (0, react_1.useState)(userManager.unit), unit = _m[0], setUnit = _m[1];
    var _o = (0, react_1.useState)(false), moveIn = _o[0], setIn = _o[1];
    var _p = (0, react_1.useState)(false), moveOut = _p[0], setOut = _p[1];
    var _q = (0, react_1.useState)('Delivery'), inText = _q[0], setInText = _q[1];
    var _r = (0, react_1.useState)('Disposal'), outText = _r[0], setOutText = _r[1];
    var reserve = function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('elevator_booking[start]', String(selectedStartDate));
        formData.append('elevator_booking[end]', String(selectedEndDate));
        formData.append('elevator_booking[moveType]', String(moveType));
        if (name1) {
            formData.append('elevator_booking[name1]', String(name1));
        }
        if (name2) {
            formData.append('elevator_booking[name2]', String(name2));
        }
        if (phoneDay) {
            formData.append('elevator_booking[phone_day]', String(phoneDay));
        }
        if (phoneNight) {
            formData.append('elevator_booking[phone_night]', String(phoneNight));
        }
        if (unit) {
            formData.append('elevator_booking[unit]', String(unit));
        }
        formData.append('elevator_booking[in]', String(moveIn));
        formData.append('elevator_booking[out]', String(moveOut));
        formData.append('elevator_booking[deposit]', String(deposit));
        userManager.createElevatorBooking(formData)
            .then(function (response) {
            if (response.success === true) {
                setThanks(true);
                setSelectedStartDateChange(new Date());
                setSelectedEndDateChange(new Date());
                setErrorMessage('');
            }
            else if (response.error === 'Unprocessable Entity') {
                var err = 'Please make sure you have filled out the form correctly.';
                setErrorMessage(err);
            }
            else if (response.error) {
                setErrorMessage(response.error);
            }
        });
    };
    var computeDeposit = function (mt, sd, ed) {
        var fees = {
            deposit: 500,
            weekday: {
                cost: 200,
                extra: 50,
            },
            weekend: {
                cost: 300,
                extra: 75,
            },
        };
        if (mt === 2) {
            var numberOfHours = Math.ceil(((ed.getTime() - sd.getTime()) / 1000) / 60 / 60);
            if (numberOfHours < 4) {
                numberOfHours = 4;
            }
            if (ed.getDay() === 6) {
                var dep = fees.deposit + fees.weekend.cost + (fees.weekend.extra * (numberOfHours - 4));
                setDeposit(dep);
            }
            else {
                var dep = fees.deposit + fees.weekday.cost + (fees.weekday.extra * (numberOfHours - 4));
                setDeposit(dep);
            }
        }
    };
    var handleNativeDateChange = function (date) {
        var constDate = new Date(date);
        var tzo = new Date().getTimezoneOffset();
        var changedDate = (0, moment_1.default)(constDate).add(tzo, 'm').toDate();
        var startDate = new Date(changedDate.getFullYear(), changedDate.getMonth(), changedDate.getDate(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getHours()) || new Date().getHours(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getMinutes()) || new Date().getMinutes());
        setSelectedStartDateChange(startDate);
        var endDate = new Date(changedDate.getFullYear(), changedDate.getMonth(), changedDate.getDate(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getHours()) || new Date().getHours(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getMinutes()) || new Date().getMinutes());
        setSelectedEndDateChange(endDate);
        computeDeposit(moveType, startDate, endDate);
    };
    var handleNativeStartTimeChange = function (date) {
        var _a = date.split(':'), hour = _a[0], minute = _a[1];
        var startDate = new Date((selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getFullYear()) || new Date().getFullYear(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getMonth()) || new Date().getMonth(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getDate()) || new Date().getDate(), Number(hour), Number(minute));
        var roundedStart = roundToMinuteInterval(startDate, 15);
        setSelectedStartDateChange(roundedStart);
        computeDeposit(moveType, roundedStart, selectedEndDate);
    };
    var handleNativeEndTimeChange = function (date) {
        var _a = date.split(':'), hour = _a[0], minute = _a[1];
        var endDate = new Date((selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getFullYear()) || new Date().getFullYear(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getMonth()) || new Date().getMonth(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getDate()) || new Date().getDate(), Number(hour), Number(minute));
        var roundedEnd = roundToMinuteInterval(endDate, 15);
        setSelectedEndDateChange(roundedEnd);
        computeDeposit(moveType, selectedStartDate, roundedEnd);
    };
    var handleIn = function (event) {
        if (event.target.checked) {
            setIn(true);
        }
        else {
            setIn(false);
        }
    };
    var handleOut = function (event) {
        if (event.target.checked) {
            setOut(true);
        }
        else {
            setOut(false);
        }
    };
    var handleTypeChange = function (event) {
        setMoveType(Number(event.target.value));
        if (event.target.value === '1') {
            setDeposit(0);
            setInText('Delivery');
            setOutText('Disposal');
        }
        else if (event.target.value === '2') {
            setInText('Move in');
            setOutText('Move out');
            computeDeposit(Number(event.target.value), selectedStartDate, selectedEndDate);
        }
    };
    (0, react_1.useEffect)(function () {
        if (userManager.userType !== condo_brain_1.UserType.Owner) {
            setMoveType(1);
        }
    }, [userManager]);
    return (react_1.default.createElement("div", null,
        thanks && (react_1.default.createElement("div", { className: "section flex-grow" },
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 1 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement("h4", { className: "center" }, "Elevator Reservation Submitted"),
                    react_1.default.createElement("p", { className: "center" },
                        "Thank you!",
                        '  ',
                        "You will recieve an email when we confirm your elevator reservation or if we have additional questions.",
                        '  '))))),
        !thanks && (react_1.default.createElement("form", { noValidate: true, autoComplete: "off", onSubmit: reserve },
            react_1.default.createElement("div", { className: "section flex-grow" },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement("h4", { className: "center" }, "Reserve Elevator"),
                        react_1.default.createElement(material_1.Alert, { severity: "info" },
                            react_1.default.createElement(material_1.AlertTitle, null, "Available hours"),
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Moving")),
                            react_1.default.createElement("p", null, "Elevator booking hours are Monday to Friday 9 AM - 5 PM and Saturdays 9 AM - 3 PM for moving. Only owners can book the elevator for moves. If you are a tenant please contact your landlord."),
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Deliveries & Disposals")),
                            react_1.default.createElement("p", null, "Elevator booking hours are Monday to Friday 9 AM - 3 PM and Saturdays 9 AM - 12 PM for deliveries and disposals. There is one delivery space available for each morning and afternoon."),
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Elevators are not available to book on Sundays or statutory holidays.")),
                            react_1.default.createElement("p", null)),
                        errorMessage !== '' && (react_1.default.createElement(material_1.Alert, { severity: "error" },
                            react_1.default.createElement(material_1.AlertTitle, null, "Error"),
                            errorMessage))),
                    react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.InputLabel, { htmlFor: "age-native-simple" }, "Type"),
                            react_1.default.createElement(material_1.Select, { native: true, value: String(moveType), onChange: handleTypeChange, inputProps: {
                                    name: 'moveType',
                                    id: 'moveType',
                                }, style: { width: '100%' } },
                                react_1.default.createElement("option", { "aria-label": "None", value: "" }),
                                react_1.default.createElement("option", { key: "delivery", value: "1" }, "Delivery / Disposal"),
                                userManager.userType === condo_brain_1.UserType.Owner && (react_1.default.createElement("option", { key: "move", value: "2" }, "Move")))),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "start", label: "Date", type: "date", defaultValue: formatDate(selectedStartDate), onChange: function (e) { return handleNativeDateChange(e.target.value); }, InputLabelProps: {
                                    shrink: true,
                                }, sx: { width: '100%' } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "startTime", label: "Start Time", type: "time", value: formatTime(roundToMinuteInterval(selectedStartDate, 15)), onChange: function (e) { return handleNativeStartTimeChange(e.target.value); }, InputLabelProps: {
                                    shrink: true,
                                }, sx: { width: '100%' } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "endTime", label: "End Time", type: "time", value: formatTime(roundToMinuteInterval(selectedEndDate, 15)), onChange: function (e) { return handleNativeEndTimeChange(e.target.value); }, InputLabelProps: {
                                    shrink: true,
                                }, sx: { width: '100%' } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "name1", label: "Resident 1", style: { width: '100%' }, value: name1 || '', onChange: function (e) { return setName1(e.target.value); } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "name2", label: "Resident 2 (if applicable)", style: { width: '100%' }, value: name2 || '', onChange: function (e) { return setName2(e.target.value); } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "phoneDay", label: "Daytime number", style: { width: '100%' }, value: phoneDay || '', onChange: function (e) { return setPhoneDay(e.target.value); } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "phoneNight", label: "Evening number", style: { width: '100%' }, value: phoneNight || '', onChange: function (e) { return setPhoneNight(e.target.value); } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                            react_1.default.createElement(material_1.TextField, { id: "unit", label: "Unit", style: { width: '100%' }, value: unit || '', onChange: function (e) { return setUnit(Number(e.target.value)); } })),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, moveType !== 0 && (react_1.default.createElement("div", null,
                            react_1.default.createElement(material_1.FormControlLabel, { control: (react_1.default.createElement(material_1.Checkbox, { checked: moveIn, onChange: handleIn, name: inText, color: "primary" })), label: inText }),
                            react_1.default.createElement(material_1.FormControlLabel, { control: (react_1.default.createElement(material_1.Checkbox, { checked: moveOut, onChange: handleOut, name: outText, color: "primary" })), label: outText })))),
                        moveType === 2 && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(material_1.Alert, { severity: "warning" },
                                react_1.default.createElement(material_1.AlertTitle, null, "You will be contacted for the below moving fee"),
                                react_1.default.createElement("ul", null,
                                    react_1.default.createElement("li", null, " $500 refundable deposit"),
                                    react_1.default.createElement("li", null, " Non-refundable fee (up to 4 hours):"),
                                    react_1.default.createElement("ul", null,
                                        react_1.default.createElement("li", null, "$200 weekday + $50 / hour over 4 hours"),
                                        react_1.default.createElement("li", null, "$300 Saturday + $75 / hour over 4 hours"))),
                                react_1.default.createElement("p", null,
                                    "Deposit",
                                    ' ',
                                    "$500",
                                    react_1.default.createElement("br", null),
                                    "Fee",
                                    ' ',
                                    "$",
                                    deposit - 500,
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement("strong", null,
                                        "Total due: $",
                                        deposit))))),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(material_1.Typography, null,
                                "Please ensure that you follow the posted instructions as well as complying with the",
                                ' ',
                                react_1.default.createElement(material_1.Link, { href: "https://wscc556.frontsteps.com/folders/", target: "_blank", rel: "noopener" }, "Arrow Lofts condo rules"),
                                ".")),
                        moveType !== 0 && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center" },
                            react_1.default.createElement(material_1.Button, { variant: "contained", type: "submit", sx: {
                                    backgroundColor: '#f37f30',
                                    color: 'white',
                                    marginBottom: '20px',
                                }, endIcon: react_1.default.createElement(material_1.Icon, null, "add") }, "Reserve Elevator"))))))))));
}
exports.default = ElevatorBooking;
